import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    question: "What is MōdForge?",
    answer:
      "MōdForge is a complete self-improvement ecosystem designed to help you build discipline, crush goals, and break bad habits. Think of it as your personal forge — where raw potential gets hammered into unbreakable strength through daily action, accountability, and community.",
  },
  {
    question: "Who is MōdForge for?",
    answer:
      "MōdForge is for anyone serious about leveling up — whether you're quitting a bad habit, building a morning routine, chasing fitness goals, or just trying to become more disciplined. It's built for men and women who are done making excuses and ready to put in the work.",
  },
  {
    question: "How does MōdForge work?",
    answer:
      "You set goals, build routines, and track habits daily. Every action you complete earns you GRIT points — our internal currency that reflects your real-world effort. As you progress, you unlock ranks, earn badges, and can even get featured in the Hall of Forged. The app also includes mood tracking, journaling, focus sessions, MōdCoach, and a supportive community.",
  },
  {
    question: "What are GRIT points?",
    answer:
      "GRIT points are earned by completing routines, hitting goals, logging habits, journaling, and staying consistent. They represent your accumulated discipline and unlock ranks, badges, and premium features. The more you show up, the more GRIT you earn.",
  },
  {
    question: "Is MōdForge free to use?",
    answer:
      "MōdForge is currently in testing and under construction — we're still figuring out our pricing model. In the meantime, we're giving out promo codes for early access. Email us at support@realwordsonly.com to request one!",
  },
  {
    question: "What is the Forge Masters section?",
    answer:
      "Forge Masters is a curated library of motivational and educational content from top creators across fitness, mindset, discipline, and personal growth. It's designed to fuel your transformation journey with real, actionable inspiration.",
  },
  {
    question: "What is the Hall of Forged?",
    answer:
      "The Hall of Forged is where the community's most impressive transformations are showcased. Members are nominated by AI based on their consistency, improvement, and milestones — it's the ultimate recognition for putting in the work.",
  },
  {
    question: "Can I use MōdForge on my phone?",
    answer:
      "Absolutely. MōdForge is a progressive web app (PWA), meaning you can install it directly to your phone's home screen from your browser — no app store needed. It works seamlessly on mobile, tablet, and desktop.",
  },
];

export const HomeFAQ = () => {
  return (
    <section className="py-24 px-4" id="faq">
      <div className="container mx-auto max-w-3xl">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-display tracking-wider text-center mb-4">
          <span className="text-gradient-ember">FAQ</span>
        </h2>
        <p className="text-center text-muted-foreground mb-12 max-w-xl mx-auto">
          Everything you need to know before you start forging.
        </p>

        <Accordion type="single" collapsible className="w-full space-y-2">
          {faqs.map((faq, i) => (
            <AccordionItem
              key={i}
              value={`faq-${i}`}
              className="border border-border/50 rounded-lg px-5 bg-card/30 backdrop-blur-sm"
            >
              <AccordionTrigger className="text-left hover:no-underline text-foreground font-semibold">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground leading-relaxed">
                {faq.question === "Is MōdForge free to use?" ? (
                  <>
                    MōdForge is currently in testing and under construction — we're still figuring out our pricing model. In the meantime, we're giving out promo codes for early access. Email us at{" "}
                    <a href="mailto:support@realwordsonly.com" className="text-primary hover:underline font-medium">
                      support@realwordsonly.com
                    </a>{" "}
                    to request one!
                  </>
                ) : (
                  faq.answer
                )}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};
